import { useEffect, useState } from 'react';
import Login from '@cont/Login/Login';
import Drawer from '@base/Drawer/Drawer';
import { useRouter } from 'next/router';
import isEmpty from 'lodash/isEmpty';
import Layout from '@layout/index';
import PageReduxProvider from '@cont/App/PageReduxProviderWrapper';
import useGeoLocation from '@api/hooks/useGeoLocation';

const LoginFlow = () => {
  const geoLocationData = useGeoLocation();

  const [showDrawer, setShowDrawer] = useState(true);
  const [info, setInfo] = useState(null);
  const router = useRouter();

  useEffect(() => {
    if (!isEmpty(router.query)) {
      setInfo({ email: atob(router.query.email), token: router.query.token });
    }
  }, [router.query]);

  const onClose = () => {
    setShowDrawer(false);
  };

  return (
    <>
      pawn
      {info && !isEmpty(geoLocationData) && (
        <Drawer login drawerState={showDrawer} onClose={onClose}>
          <Login
            showGoogleSingup={false}
            createPasswordToken={{ token: info.token, email: info.email }}
          />
        </Drawer>
      )}
    </>
  );
};

export default LoginFlow;
LoginFlow.Layout = Layout;
LoginFlow.Wrapper = PageReduxProvider;
